import React from 'react';
import './PPG_Offer_status.css';
import { split } from 'lodash';

export default function OfferMessage(){
  const url = window.location.href;
  const urlName = new URL(url)
  const urlMicrosite = split(urlName.search, '?microsite=');
  const urlParam = split(urlName.search, '&event=');
  const micrositeName = split(urlMicrosite[1], '&event=');
  const statusName = urlParam[1];
  return(
        <div className='offer_container'>
            {statusName === "signing_complete" && <div className='offer_main_content'>
                <a href="/">
                <img className='image_success' src="/assets/logos/Color_H.png" width="140px" height="68px"/>
                </a>
                <hr className='underline' style={{backgroundColor:"#3c88c5"}} />
                <p className='thanks'> &#x2713;</p>
                <p className='thanks_desc'>Great! You've successfully signed the PPG agreement.</p>
                <a className='button_text' href={"/" + micrositeName[0]}>Go to Home Page</a>
            </div>}
            {statusName === "decline" && <div className='offer_main_content'>
                <a href="/">
                <img className='image_success' src="/assets/logos/Color_H.png" width="140px" height="68px"/>
                </a>
                <hr className='underline' />
                <p className='thanksUnsuccess'> &#x2717;</p>
                <p className='thanks_desc'>You have declined the PPG offer. Please contact a Calque team representative at <span style={{color: '#2661AB', fontWeight: 'bold'}}>(512) 894-9629</span> to obtain a new signing URL.</p>
                <a className='button_text' href={"/" + micrositeName[0]}>Go to Home Page</a>
            </div>}
            {statusName === "cancel" && <div className='offer_main_content'>
                <a href="/">
                <img className='image_success' src="/assets/logos/Color_H.png" width="140px" height="68px"/>
                </a>
                <hr className='underline' />
                <p className='thanksUnsuccess'> &#x2717;</p>
                <p className='thanks_desc'>You have not completed the signing process.</p>
                <a className='button_text' href={"/" + micrositeName[0]}>Go to Home Page</a>
            </div>}
            {statusName === "ttl_expired" && <div className='offer_main_content'>
                <a href="/">
                <img className='image_success' src="/assets/logos/Color_H.png" width="140px" height="68px"/>
                </a>
                <hr className='underline' />
                <p className='thanksUnsuccess'> &#x2717;</p>
                <p className='thanks_desc'>Your signing URL has been expired. Please contact a Calque team representative at <span style={{color: '#2661AB', fontWeight: 'bold'}}>(512) 894-9629</span> to obtain a new signing URL.</p>
                <a className='button_text' href={"/" + micrositeName[0]}>Go to Home Page</a>
            </div>}
        </div>
    )
}